import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const KEY = "mw_cookie_consent";

const applyConsent = (value) => {
  const ph = window.posthog;
  if (!ph) return;
  if (value === "accepted") ph.opt_in_capturing?.();
  else ph.opt_out_capturing?.();
};

export const CookieBanner = () => {
  const [open, setOpen] = useState(false);
  const [settings, setSettings] = useState(false);
  const [analytics, setAnalytics] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    if (stored) applyConsent(stored);
    else setOpen(true);
    const onOpen = () => { setAnalytics(localStorage.getItem(KEY) === "accepted"); setSettings(true); setOpen(true); };
    window.addEventListener("mw:cookie-settings", onOpen);
    return () => window.removeEventListener("mw:cookie-settings", onOpen);
  }, []);

  const save = (value) => {
    localStorage.setItem(KEY, value);
    applyConsent(value);
    setOpen(false);
    setSettings(false);
  };

  if (!open) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookie preferences" data-testid="cookie-banner">
      <div className="flex items-start gap-3">
        <span className="icon-tile orange shrink-0" style={{ width: 38, height: 38 }}><Cookie size={18} /></span>
        <div className="flex-1 text-[13px] text-[#1A1A1A] leading-relaxed">
          <div className="font-bold text-[#002B7F] text-[14px]">Cookies on this website</div>
          <p className="mt-1 text-[#4A4A4A]">
            We use essential storage to make the site work and, with your consent, analytics cookies to understand how it is used. Read our{" "}
            <Link to="/cookie-policy" className="underline text-[#002B7F]" data-testid="cookie-policy-link">Cookie Policy</Link>.
          </p>
          {settings && (
            <label className="mt-3 flex items-center gap-3 rounded-xl border border-[#E6EAF0] bg-[#F5F7FA] p-3 cursor-pointer" data-testid="cookie-analytics-toggle">
              <input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} className="accent-[#F37021] w-4 h-4" />
              <span><span className="font-semibold">Analytics cookies</span> <span className="text-[#6B7280]">(PostHog) — optional</span></span>
            </label>
          )}
          <div className="mt-3 flex flex-wrap gap-2">
            {settings ? (
              <button type="button" onClick={() => save(analytics ? "accepted" : "rejected")} className="btn-orange text-[13px] px-4 py-2" data-testid="cookie-save">Save preferences</button>
            ) : (
              <>
                <button type="button" onClick={() => save("accepted")} className="btn-orange text-[13px] px-4 py-2" data-testid="cookie-accept">Accept analytics</button>
                <button type="button" onClick={() => save("rejected")} className="btn-ghost text-[13px] px-4 py-2" data-testid="cookie-reject">Essential only</button>
                <button type="button" onClick={() => setSettings(true)} className="text-[13px] font-semibold text-[#002B7F] px-2 hover:text-[#F37021] transition-colors" data-testid="cookie-settings">Settings</button>
              </>
            )}
          </div>
        </div>
        <button type="button" onClick={() => save("rejected")} className="text-[#6B7280] hover:text-[#1A1A1A] transition-colors" aria-label="Close and use essential only" data-testid="cookie-close"><X size={16} /></button>
      </div>
    </div>
  );
};
